(ns ductile.compound-config
  "This namespace contains the compound specific settings. All times listed here are meant to be local to the compound."
  (:require [ductile.ui.locale :refer [tr]]))

(defn extra-hour-companies [compound-name]
  (case compound-name
    ("Piadena" "Lonato" "ARVAL-P3" "Frosinone")
    #{"STA SRL"
      "TRA.DE TRASPORTI E DEPOSITI SRL"
      "MENAKLARS S.R.L."
      "Menaklars GmbH"}
    #{}))

(def full-week ["monday" "tuesday" "wednesday" "thursday" "friday" "saturday" "sunday"])
(def weekdays (take 5 full-week))
(def weekend (drop 5 full-week))

(def italian-used-brands-truck-booking
  #{"OPENLANE" "ALD" "Amazon" "ARVAL" "Athlon" "Autohero" "AVIS" "Barchetti"
    "BCA" "BMW" "Carvago" "Drive" "FCA" "FORD" "Gruppo Bossoni" "Hertz" "Leasys" "Locauto"
    "Mercedes" "Noleggiare" "PSA" "Renault" "Rent2Go" "SIXT" "VGI" "VWFS"})

(def piadena-config
  {:compound/entry-modes #{:mode/truck :mode/train :mode/own-wheels}
   :entry/truck-types #{:entry.truck/carrier}
   :compound/legacy-arrival-scan true
   :compound/enforce-loading-area-assignment? true
   :compound/booking-slots 3
   :compound/locale :it
   :compound/modules #{:module/base :module/truck-booking :module/vin-list :module/accessories :module/elog-interface}
   :compound/unloading-lines 10
   :booking/new-vehicle-make-required? true
   :compound/timezone "Europe/Rome"
   :compound/booking-slots+times (into {}
                                       (map (fn [d] [d {[8 17] 3}]))
                                       weekdays)
   :compound/extended-booking-slots+times (into {}
                                                (map (fn [d] [d {[7 20] 3}]))

                                                weekdays)
   :compound/special-slots+times {"2023-12-08" {}
                                  "2023-12-09" {}
                                  "2023-12-10" {}
                                  "2023-12-23" {}
                                  "2023-12-24" {}
                                  "2023-12-25" {}
                                  "2023-12-26" {}
                                  "2023-12-30" {}
                                  "2023-12-31" {}
                                  "2024-01-01" {}
                                  "2024-01-06" {}
                                  "2024-01-07" {}
                                  "2024-04-01" {}
                                  "2024-04-25" {}
                                  "2024-05-01" {}
                                  "2024-08-15" {}
                                  "2024-08-16" {}
                                  "2024-11-01" {}
                                  "2024-12-25" {}
                                  "2024-12-26" {}
                                  "2024-12-27" {}}})



(def compound-config
  {"Civitavecchia"
   {:compound/entry-modes #{:mode/truck :mode/ship :mode/train}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/default-email-address "civit.kia.geda@canada-srl.it"
    :compound/bulk-entry? true
    :compound/bulk-entry-selectable-services? true
    :compound/parking-mode? true
    :compound/external-fpr? true
    :compound/enforce-loading-area-assignment? true
    :compound/modules #{:module/base :module/workflow :module/truck-booking}
    :compound/locale :it
    :compound/timezone "Europe/Rome"
    :compound/booking-slots 4
    :compound/unloading-lines 7
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 17] 4}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[8 17] 4}]))
                                                 weekdays)
    :compound/special-slots+times {"2024-04-01" {}
                                   "2024-04-25" {}
                                   "2024-05-01" {}
                                   "2024-08-15" {}
                                   "2024-08-16" {}
                                   "2024-11-01" {}
                                   "2024-12-25" {}
                                   "2024-12-26" {}
                                   "2024-12-27" {}}
    :booking/new-vehicle-make-required? true
    :compound/show-reparking-button? true}
   "Lonato"
   {:compound/entry-modes #{:mode/truck :mode/train :mode/own-wheels}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/default-email-address "lonato@ars-altmann.it"
    :compound/bulk-entry? true
    :compound/parking-mode? true
    :compound/enforce-loading-area-assignment? true
    :compound/booking-slots 5
    :compound/locale :it
    :compound/modules #{:module/base :module/workflow :module/truck-booking}
    :compound/unloading-lines 7
    :compound/timezone "Europe/Rome"
    :parking-zone/default "GZ"
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 17] 5}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[7 20] 5}]))
                                                 weekdays)
    :booking/new-vehicle-make-required? true
    :booking/used-vehicle-customer-required? true
    :booking/vehicle-customer-list italian-used-brands-truck-booking
    :compound/special-slots+times {"2024-04-25" {}
                                   "2024-05-01" {}
                                   "2024-08-15" {}
                                   "2024-08-16" {}
                                   "2024-11-01" {}
                                   "2024-12-25" {}
                                   "2024-12-26" {}
                                   "2024-12-27" {}}
    :compound/show-reparking-button? true}
   "Fiumicino"
   {:compound/entry-modes #{:mode/truck}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/default-email-address "ravenna.geda@asia-srl.com"
    :compound/legacy-arrival-scan true
    :compound/enforce-loading-area-assignment? true
    :compound/modules #{:module/base :module/workflow}
    :compound/locale :it
    :compound/timezone "Europe/Rome"}

   "Piadena"
   piadena-config

   "Castiglione delle Stiviere"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/legacy-arrival-scan true
    :compound/enforce-loading-area-assignment? true
    :compound/locale :it
    :compound/timezone "Europe/Rome"
    :compound/modules #{:module/base :module/truck-booking}
    :compound/unloading-lines 4
    :booking/new-vehicle-make-required? true
    :booking/used-vehicle-customer-required? true
    :booking/vehicle-customer-list (conj italian-used-brands-truck-booking "KINTO")
    :compound/booking-slots 2
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 17] 2}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[8 17] 2}]))
                                                 weekdays)}

   "ARVAL-P3"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/legacy-arrival-scan true
    :compound/enforce-loading-area-assignment? true
    :compound/locale :it
    :compound/timezone "Europe/Rome"
    :compound/modules #{:module/base :module/truck-booking}
    :compound/unloading-lines 4
    :booking/new-vehicle-make-required? true
    :compound/booking-slots 2
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 17] 2}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[8 17] 2}]))
                                                 weekdays)
    :compound/special-slots+times {"2024-04-01" {}
                                   "2024-04-25" {}
                                   "2024-05-01" {}
                                   "2024-08-15" {}
                                   "2024-08-16" {}
                                   "2024-11-01" {}
                                   "2024-12-25" {}
                                   "2024-12-26" {}
                                   "2024-12-27" {}}}
   "Tor Cervara"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/locale :it
    :compound/timezone "Europe/Rome"
    :compound/modules #{:module/base :module/truck-booking}
    :compound/unloading-lines 4
    :booking/new-vehicle-make-required? true
    :compound/booking-slots 2
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[9 17] 2}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[9 17] 2}]))
                                                 weekdays)}
   "Frosinone"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/locale :it
    :compound/legacy-arrival-scan true
    :compound/enforce-loading-area-assignment? true
    :compound/booking-slots 3
    :compound/modules #{:module/base :module/truck-booking}
    :compound/unloading-lines 6
    :compound/timezone "Europe/Rome"
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 17] 3}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[8 17] 3}]))
                                                 weekdays)
    :booking/new-vehicle-customer-required? true
    :booking/used-vehicle-customer-required? true

    :booking/vehicle-customer-list #{"OPENLANE" "ALD" "Amazon" "Athlon" "Autohero" "AVIS"
                                     "BCA" "BMW" "FCA" "FORD" "Hertz" "Leasys" "Locauto"
                                     "Mercedes" "Noleggiare" "PSA" "Renault" "SIXT" "VGI"}
    :compound/special-slots+times {"2023-12-08" {}
                                   "2023-12-09" {}
                                   "2023-12-10" {}
                                   "2023-12-23" {}
                                   "2023-12-24" {}
                                   "2023-12-25" {}
                                   "2023-12-26" {}
                                   "2023-12-30" {}
                                   "2023-12-31" {}
                                   "2024-01-01" {}
                                   "2024-01-06" {}
                                   "2024-01-07" {}
                                   "2024-04-25" {}
                                   "2024-05-01" {}
                                   "2024-08-15" {}
                                   "2024-08-16" {}
                                   "2024-11-01" {}
                                   "2024-12-25" {}
                                   "2024-12-26" {}
                                   "2024-12-27" {}}}

   "Krefeld"
   {:compound/entry-modes #{:mode/truck :mode/train :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/load-automatically-ready-when-prepared? true
    :compound/use-gate-to-record-entry-transport-data? true
    :compound/enforce-loading-area-assignment? true
    :compound/timezone "Europe/Berlin"
    :parking/max-fahrzeuge-per-parking-spot 1
    :compound/locale :de
    :parking-zone/default "FZ-EIN_LKW"
    :compound/modules #{:module/base :module/workflow :module/billing :module/elog-interface}}

   "Ravenna"
   {:compound/entry-modes #{:mode/truck :mode/train :mode/ship}
    :entry/truck-types #{:entry.truck/carrier}
    :compound/bulk-entry? true
    :compound/parking-mode? true
    :compound/enforce-loading-area-assignment? true
    :compound/timezone "Europe/Rome"
    :compound/locale :it
    :compound/unloading-lines 7
    :booking/new-vehicle-make-required? true
    :compound/bulk-entry-selectable-services? true
    :compound/modules #{:module/base :module/workflow :module/truck-booking}
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 17] 4}]))
                                        weekdays)
    :compound/extended-booking-slots+times (into {}
                                                 (map (fn [d] [d {[8 17] 4}]))
                                                 weekdays)
    :compound/show-reparking-button? true}

   "Riedstadt"
   {:compound/entry-modes #{:mode/truck :mode/train :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/timezone "Europe/Berlin"
    :compound/locale :de
    :compound/unloading-lines 9
    :compound/enforce-loading-area-assignment? true
    :booking/new-vehicle-customer-required? true
    :booking/used-vehicle-customer-required? true
    :booking/vehicle-customer-list #{"ASS" "AVIS" "OPENLANE" "Alphabet" "Arval"
                                     "Auktion&Markt" "AutoScout" "BCA" "BMW" "Cargentur"
                                     "DeTeFleet" "Enterprise" "Mercedes" "SHARE NOW" "SIXT"
                                     "Schwarz Mobility" "Smyle24" "Stellantis" "VW"}
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[0 7] 2
                                                         [7 17] 3
                                                         [17 24] 2}]))
                                        full-week)
    :compound/modules #{:module/base :module/workflow :module/truck-booking}
    :compound/workflows [{:ui/icon :tire
                          :workflow/title (tr "Wheel Set Entry")
                          :workflow/type "wheel-set-entry"
                          :workflow/scope :scope/workflow}
                         {:ui/icon :tire
                          :workflow/title (tr "Wheel Set Management")
                          :workflow/type "wheel-set"
                          :workflow/scope :scope/workflow}]}

   "Hodenhagen"
   {:compound/entry-modes #{:mode/truck :mode/train :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/enforce-loading-area-assignment? true
    :compound/timezone "Europe/Berlin"
    :compound/locale :de
    :compound/modules #{:module/base :module/workflow}
    :compound/workflows [{:ui/icon :tire
                          :workflow/title (tr "Wheel Set Entry")
                          :workflow/type "wheel-set-entry"
                          :workflow/scope :scope/workflow}
                         {:ui/icon :tire
                          :workflow/title (tr "Wheel Set Management")
                          :workflow/type "wheel-set"
                          :workflow/scope :scope/workflow}]}

   "Eitting"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/timezone "Europe/Berlin"
    :compound/locale :de
    :compound/unloading-lines 1
    :parking-zone/default "Quarantäne SP3"
    :compound/booking-slots+times (into {}
                                        (map (fn [d] [d {[8 16] 1}]))
                                        weekdays)
    :compound/load-automatically-ready-when-prepared? true
    :booking/skip-new-vehicles? true
    :booking/skip-used-vehicles? true
    :compound/enforce-loading-area-assignment? false
    :compound/modules #{:module/base :module/workflow :module/elog-interface :module/truck-booking}
    :compound/workflows [{:ui/icon :tire
                          :workflow/title (tr "Wheel Set Entry")
                          :workflow/type "wheel-set-entry"
                          :workflow/scope :scope/workflow}
                         {:ui/icon :tire
                          :workflow/title (tr "Wheel Set Management")
                          :workflow/type "wheel-set"
                          :workflow/scope :scope/workflow}]}

   "Knautnaundorf"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/enforce-loading-area-assignment? true
    :compound/timezone "Europe/Berlin"
    :compound/locale :de
    :parking-zone/default "FZ_EIN_LKW"
    :compound/modules #{:module/base :module/workflow :module/elog-interface}
    :compound/workflows [{:ui/icon :tire
                          :workflow/title (tr "Wheel Set Entry")
                          :workflow/type "wheel-set-entry"
                          :workflow/scope :scope/workflow}
                         {:ui/icon :tire
                          :workflow/title (tr "Wheel Set Management")
                          :workflow/type "wheel-set"
                          :workflow/scope :scope/workflow}]}

   "Klitschmar"
   {:compound/entry-modes #{:mode/truck :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/enforce-loading-area-assignment? true
    :compound/timezone "Europe/Berlin"
    :compound/locale :de
    :compound/modules #{:module/base :module/workflow :module/elog-interface}}

   "Wolnzach"
   {:compound/entry-modes #{:mode/truck :mode/train :mode/own-wheels}
    :entry/truck-types #{:entry.truck/ars :entry.truck/carrier}
    :compound/enforce-loading-area-assignment? true
    :compound/timezone "Europe/Berlin"
    :compound/locale :de
    :compound/elog-compound? true
    :compound/modules #{:module/base :module/workflow}}})

(defn get-compound-config [compound-name]
  (or (compound-config compound-name)
      (throw (ex-info "compound not found" {:compound-name compound-name}))))

(defn timezone-at #?(:clj ^java.time.ZoneId [compound-name]
                     :cljs [compound-name])
  (-> (get-compound-config compound-name)
      :compound/timezone
      #?(:clj java.time.ZoneId/of)))

(defn locale-at [compound-name]
  (-> (get-compound-config compound-name)
      :compound/locale))

(comment
  (timezone-at "Ravenna"))

(defn module-enabled? [compound-name module]
  (contains? (:compound/modules (get-compound-config compound-name)) module))

(defn legacy-arrival-scan? [compound-name]
  (boolean (:compound/legacy-arrival-scan (get-compound-config compound-name))))